

































































































































































import AccountTerms from '@/components/AccountTerms.vue'
import Address from '@/types/Address.interface'
import AddressBlock from '@/components/AddressBlock.vue'
import Role from '@/types/Role.interface'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
import Tenant from '@/types/Tenant.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import PersonShowTitle from '@/components/PersonShowTitle.vue'
import { timezoneUpdate } from '@/utility/helpers'
import Analytics from '@/services/Analytics'
import tenant from '@/store/data/tenant'
import { VCardText } from 'vuetify/lib'
import User from '@/types/User.interface'
export default Vue.extend({
    mixins: [subscriptionMixin],
    components: { AccountTerms, AddressBlock, PersonShowTitle, VCardText },
    data() {
        return {
            loading: false,
            toolbar: {
                title: 'Account',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            },
            resend: null,
            verifyCode: null
        }
    },
    computed: {
        ...mapGetters([
            'authIsAdmin',
            'authIsSupport',
            'phoneOrder',
            'productTier',
            'smsAccount',
            'tenant',
            'user'
        ]),
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        A2PRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            //  If our setting doesn't exist, return false
            if (!a2pEnabled) return false

            //  Else, return based on if we are enabled or not
            return !!a2pEnabled.enabled
        },
        address(): Address {
            // If the tenant does NOT exist, return nothing
            if (!this.tenant) return null

            //  Else, map the tenant into an address object
            return {
                line1: this.tenant.line1,
                line2: this.tenant.line2,
                city: this.tenant.city,
                // The reason this can be defaulted to '' is because it doesn't affect the address format and thus
                // doesn't need a unique if case in addressString()
                country_subdivision: this.tenant.country_subdivision || '',
                postalcode: this.tenant.postalcode || ''
            }
        },
        addressString(): string {
            //  If we have no address, return empty string
            if (!this.address.line1) {
                return ''
            }

            //  Create a clone of our address so we don't end up modifying the existing
            const addr = { ...this.address }

            //  If we have a line2 of our address then we need to add a comma after line 2
            if (addr.line2) addr.line2 = `${addr.line2},`
            //  Else, add a comma after line 1
            else addr.line1 = `${addr.line1},`

            //  Our end string will be country subdivision and postal code
            const endStr = `${addr.country_subdivision} ${addr.postalcode}`

            //  If we DO have a country subdivision or postal code, append a comma to our city
            addr.city = endStr.trim() ? `${addr.city},` : addr.city

            //  Return our address as a string
            return Object.values(addr).join(' ')
        },
        callForwardingForRender(): object {
            //  Check if a call forwarding number has already been set
            const number = this.smsAccount && this.smsAccount.call_forwarding_number

            //  If a forwarding number is set, return it
            //  Else, return empty number
            return number ? this.$options.filters.phone(number) : 'Setup Call Forwarding'
        },
        //  Return true if user has canceled
        canceled(): boolean {
            return (
                this.subscription &&
                (this.subscription.status === 'canceled' ||
                    this.subscription.cancel_at_period_end)
            )
        },
        disabled(): boolean {
            return this.loading || !this.verifyCode
        },
        resellerBlock(): boolean {
            //  If we have no users, return false
            if (!this.$store.getters.users.length) return false

            //  Grab the user's role
            const role = this.$store.getters.userRole(this.user)

            //  If they are a support user, return false
            if (role.id > 4) return false

            //  Else, get the admin user id
            const adminId = this.$store.getters.tenant.admin_user_id

            //  If the current user is the admin, return false
            if (adminId === this.user.id) return false

            //  Else, grab the admin user based on id
            const admin = this.$store.getters.users.find((x: User) => x.id === adminId)

            //  Check if this admin is a reseller
            const reseller = admin.reseller

            //  If the admin is NOT a reseller, return false
            if (!reseller) return false

            //  Else, return true
            return true
        },
        SettingsSmsNumber(): object {
            //  If the nexmo account is NOT set, return nothing
            if (!this.smsAccount) return null

            //  If the tenant does NOT have a registered sms number, return register new
            if (!this.smsAccount.msisdn) {
                return { num: 'No Number Selected', txt: 'set up' }
            }

            //  Else return text for existing registered number
            return {
                num: this.$options.filters.phone(this.smsAccount.msisdn),
                txt: 'change'
            }
        },
        tenantNumber(): string {
            //  If no sms account then return null
            if (!this.smsAccount) return null

            //  Else, grab the msisdn from the sms account
            const msisdn = this.smsAccount.msisdn

            //  Format this msisdn
            const formatted = this.$options.filters.phone(msisdn)

            //  Return the formatted number
            return formatted
        },
        userRole(): Role {
            return window.getProps(this.$store.getters.userRole(this.user), ['name'])
        }
    },
    methods: {
        changeCallForwardingNumber(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'setup-sms-forwarding',
                closeable: true,
                width: 500,
                callback: (): void => this.changeCallForwardingNumberSuccess()
            })
        },
        changeCallForwardingNumberSuccess(): void {
            //  Close the app-dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Refresh the tenant's nexmo account
            this.$store.dispatch('smsAccountGet')

            //  Notify user of success
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Number Updated',
                icon: 'mdi-check',
                color: 'primary',
                text: 'You have successfully updated your call forwarding number.'
            })

            Analytics.track('CallForwardingSetup', {
                phone_number: this.smsAccount.call_forwarding_number
            })
        },
        changeOrganizationInformation(): void {
            //  Assemble form inputs
            const inputs = [
                {
                    type: 'TEXT',
                    name: 'Address Line 1',
                    label: 'Address Line 1',
                    icon: 'mdi-format-size',
                    path: 'line1',
                    validate: 'required|max:45'
                },
                {
                    type: 'TEXT',
                    name: 'Address Line 2',
                    label: 'Address Line 2',
                    icon: 'mdi-format-size',
                    path: 'line2',
                    validate: 'max:45'
                },
                {
                    type: 'TEXT',
                    name: 'City',
                    label: 'City',
                    icon: 'mdi-format-size',
                    path: 'city',
                    validate: 'required|max:45'
                },
                {
                    type: 'dropdown',
                    name: 'State',
                    label: 'State',
                    icon: 'mdi-format-size',
                    itemText: 'stabrv',
                    itemValue: 'stabrv',
                    selected: this.tenant.country_subdivision,
                    path: 'country_subdivision',
                    options: this.$store.getters.states
                },
                {
                    type: 'TEXT',
                    name: 'Zipcode',
                    label: 'Zipcode',
                    icon: 'mdi-format-size',
                    path: 'postalcode'
                },
                {
                    type: 'dropdown',
                    name: 'Timezone',
                    label: 'Organization Timezone',
                    icon: 'mdi-format-size',
                    path: 'default_timezone',
                    selected: this.tenant.default_timezone,
                    options: [
                        {
                            value: 'Pacific/Honolulu',
                            text: 'Hawaii Standard Time (HST)'
                        },
                        {
                            value: 'America/Los_Angeles',
                            text: 'Pacific Time (PT)'
                        },
                        {
                            value: 'America/Denver',
                            text: 'Mountain Time (MT)'
                        },
                        {
                            value: 'America/Phoenix',
                            text: 'Mountain Standard Time (AZ/MST)'
                        },
                        {
                            value: 'America/Chicago',
                            text: 'Central Time (CT)'
                        },
                        {
                            value: 'America/New_York',
                            text: 'Eastern Time (ET)'
                        },
                        {
                            value: 'America/Anchorage',
                            text: 'Alaska (AKT)'
                        }
                    ],
                    validate: 'max:45'
                },
                {
                    type: 'TEXT',
                    name: 'Company Name',
                    label: 'Company Name',
                    icon: 'mdi-format-size',
                    path: 'company_name',
                    validate: 'required|max:45'
                }
            ]

            //  Pop an app-form dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Edit Organization',
                component: 'app-form',
                color: 'primary',
                closeable: true,
                props: {
                    color: 'primary',
                    model: this.tenant,
                    inputs: inputs
                },
                callback: (tenant: Tenant): void => this.organizationUpdate(tenant)
            })
        },
        disabledPopup(): void {
            //  Open a dialog informing user they cannot access x feature (in this case phone number registration)
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        async organizationUpdate(tenant): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            // Grab the current company name before we make any tenant changes, we'll use this to see if the tenant name was changed
            const currentTenantCompName = this.tenant.company_name

            //  Update the tenant
            const success = await this.$store.dispatch('tenantPut', tenant)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, no nothing
            if (!success) return

            // If the passed tenant company name is different than the one from the database then we know they changed their company name
            if (tenant.company_name !== currentTenantCompName) {
                // Report organization name change to Segment
                Analytics.track('OrganizationNameUpdated', {
                    organization_name: tenant.company_name
                })
            }

            //  Else, close dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Pop notification
            this.$store.commit('appNotificationBarSet', {
                message: 'Organization Updated',
                type: 'success'
            })
        },
        goToNumberForm(type: string): void {
            //  If the user trying to go to our number form is not an admin we tell them they cannot access this
            if (!this.authIsAdmin) return this.disabledPopup()

            //  If they are trying to register their number route them to registration form
            if (type === 'brand') return this.$router.push('/brand-info')

            //  Else our query param depends on our type
            const query = `?getNumber=${type}`

            //  Route to the home page
            this.$router.push(`/home${query}`)
        },
        goToTeam(): void {
            this.$router.push(`/teammates`)
        },
        goToSubscription(): void {
            this.$router.push('/billing/manage')
        },
        goToUser(): void {
            //  Navigate to users route
            this.$router.push(`/teammates?user=${this.user.id}&logo=true&personprof=true`)
        },
        numberHost(): void {
            window.open(
                'https://messagedesk.typeform.com/to/mDz8wsFX',
                this.$store.getters.isApp ? '_system' : '_blank'
            )
        },
        popCallForwardingHelpDialog(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                icon: 'mdi-help-circle',
                color: 'primary',
                title: 'Call Forwarding Help',
                text: `Setting up a call forwarding number enables contacts that call your MessageDesk number to be routed to a personal phone number that is capable of recieving phone calls.`
            })
        },
        async tenantAddressUpdate(tenant: Tenant): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('tenantAddressUpdate', tenant)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed do nothing
            if (!response) return

            //  Else, close the APP dialog
            this.$store.dispatch('dialogClose', 'APP')

            //  Notify user of successful update
            this.$store.commit('appNotificationBarSet', {
                message: 'Address Updated',
                type: 'success'
            })
        },
        timezoneUpdate(): void {
            timezoneUpdate()
        },
        async verifyEmail(): Promise<void> {
            //  Assemble request payload
            const payload = { code: this.verifyCode }

            //  Start the loading spinner
            this.loading = true

            //  Send the verification request
            const verified = await this.$store.dispatch('authVerifyEmail', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If not verified, tell user to try again
            if (!verified) {
                this.$store.commit('appNotificationBarSet', {
                    message: 'Verification Code Failed Please Try Again',
                    type: 'error',
                    closeable: true
                })
            }

            //  Email was verified, turn resend to null
            this.resend = null

            //  Otherwise, tell user of success
            this.$store.commit('appNotificationBarSet', {
                message: 'Email Has Been Verified!',
                type: 'success'
            })
        },
        async verifyEmailSend(): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Send a verification code to the authenticated user's email
            const sent = await this.$store.dispatch('authVerifyEmailSend')

            //  Stop the loading spinner
            this.loading = false

            //  If the email was NOT sent, do nothing
            if (!sent) return

            //  An email was sent, change text to "resend"
            this.resend = 'Resend '

            //  Else, notify the user of successfully sent email
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Verification Code Sent',
                text: `A new verification code has been sent to ${this.user.email}.`,
                icon: 'mdi-check-circle',
                color: 'primary'
            })
        }
    }
})
